module.exports = __webpack_public_path__ + "img/AI.86a61aab.svg";